<script>
    import FooterBottomText from "@/components/footer/FooterBottomText";
    import FooterPaymentIcons from "@/components/PaymentIcons";

    export default {
        name: "FooterBottom",
        components: {
            FooterBottomText,
            FooterPaymentIcons,
        },
        props: {
            /** @type {import('vue').PropOptions<"light" | "dark" | "grey">} */
            iconsColor: {
                type: String,
                default: "dark",
            },
        },
    };
</script>

<template>
    <div class="footer-bottom">
        <div class="l-container">
            <div class="footer-bottom__inner">
                <div class="footer-bottom__text">
                    <footer-bottom-text></footer-bottom-text>
                </div>

                <div class="footer-bottom__icons">
                    <footer-payment-icons
                        color="dark"
                        :exclude="['cash']"
                    ></footer-payment-icons>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .footer-bottom {
        padding: 30px 0 40px;
        background-color: var(--service-background-color);
        @include bp($bp-desktop-sm) {
            padding: 20px 0 20px;
        }
    }

    .footer-bottom__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: space-between;
        }
    }

    .footer-bottom__text {
        text-align: center;
        @include bp($bp-desktop-sm) {
            text-align: left;
        }
    }

    .footer-bottom__icons {
        max-width: 260px;
        margin: 0 auto;
        @include bp($bp-desktop-sm) {
            max-width: 100%;
            margin: 0;
        }
    }
</style>
